/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// structure
import Division from 'material/structure/division/division';
import Subhead from 'material/structure/subhead/subhead';
// pages
import LibraryPage from 'pages/dashboard/reports/library/library_container';
import DetailPage from 'pages/dashboard/reports/detail/detail_container';
import PreviewPage from 'pages/dashboard/reports/preview/preview_container';
// utils
import { Switch, Redirect } from 'react-router';
import { PrivateRoute } from 'utils/privateRoute';
import checkForLocalStorage from 'utils/checkforlocalstorage';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reports_styles';
import PervasiveMessage from 'material/message/pervasivemessage/pervasivemessage_container';


/* ========== ~~~~~~~~~~ REPORTS SECTION : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Reports extends Component {
    componentDidMount() {

        if (checkForLocalStorage() && !window.localStorage.getItem('reportsOpened')) window.localStorage.setItem('reportsOpened', 'true');

        if (!this.props.isDataReceived) this.props.getClientReportsData(this.props.accountUUID);
    }
    handleReportName = () => {
        switch (this.props.currentPage) {
            case 'dashboard/reports/detail':
            case 'dashboard/reports/preview':
                return <span className={`uniquename reportname`}>/ {this.handleReportMode()}</span>;
            case 'dashboard/reports':
            default:
                return null;
        }
    };
    handleReportMode = () => {
        switch (this.props.reportMode) {
            case 'library':
            case 'edit':
            case 'preview':
                return this.props.reportName !== "" ? this.props.reportName : 'Report Name';
            case 'create':
                return this.props.reportName !== "" ? this.props.reportName : 'New Report';
            default:
                return null;
        }
    };
    render() {
        return(
            <Division name={`reports`} klass={this.props.classes.reports}>
                <Subhead>
                    <h1>Reports {this.handleReportName()}</h1>
                </Subhead>
                <PervasiveMessage padding = {15}/>
                <Switch>
                    {/*Routes to subsections*/}
                    <PrivateRoute permitted={this.props.reportsPermitted} exact path='/dashboard/reports' component={LibraryPage} />
                    <PrivateRoute permitted={this.props.reportsPermitted && this.props.isDataReceived} redirectTo='/dashboard/reports/' exact path='/dashboard/reports/detail' component={DetailPage} />
                    <PrivateRoute permitted={this.props.reportsPermitted && this.props.isDataReceived} redirectTo='/dashboard/reports/' exact path='/dashboard/reports/preview' component={PreviewPage} />
                    <Redirect to='/error/404' />
                </Switch>
            </Division>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Reports);
